<template src="./ManualUpdate.html"></template>
<script lang="js">
import Vue from 'vue';
import {FileSizeFormatter} from "@/file-size-formatter";
import axios from "axios";
import {AnalyzeIdentifier} from "../../plugins/analyzeIdentifier";


export default Vue.extend({
  name: 'nmouc-manual-update',
  data() {
    return {
      startDownloadManagerDisabled: false,
      startDownloadManagerError: false,
    }
  },
  computed: {
    outdatedRegions() {
      return this.$store.state.mapupdateInformation.mapRegions.filter(r => !r.upToDate);
    },
    selectedRegionCount() {
      return this.$store.state.manualUpdate.selectedRegions !== undefined ? this.$store.state.manualUpdate.selectedRegions.length : 0;
    },
    completeMapRegionCount() {
      if (this.shouldOfferFullInstall) {
        return this.$store.state.mapupdateInformation.mapRegions.length;
      } else {
        return this.outdatedRegions.length;
      }
    },
    selectedFileSize() {
      if (!this.$store.state.manualUpdate.completeMapSelected) {
        return this.fileSizeOfRegions(this.$store.state.manualUpdate.selectedRegions);
      } else {
        return this.fileSizeOfAllRegions;
      }
    },
    fileSizeOfAllRegions() {
      if (this.shouldOfferFullInstall) {
        return FileSizeFormatter.formatToGB(this.$store.state.mapupdateInformation.fullInstallDownloadSize);
      } else {
        return this.fileSizeOfRegions(this.outdatedRegions);
      }
    },
    isNoneRegionSelected() {
      return !(this.$store.state.manualUpdate.completeMapSelected || this.$store.state.manualUpdate.selectedRegions.length !== 0);
    },
    shouldOfferFullInstall() {
      return this.$store.state.mapupdateInformation.offerFullInstall
    },
    ntgFunctionalDuringUpdate() {
      return this.$store.state.mapupdateInformation.ntgFunctionalDuringUpdate
    },
    analyzeIdentifier() {
      return AnalyzeIdentifier.ID;
    },
    downloadFullInstall() {
      return this.shouldOfferFullInstall && this.$store.state.manualUpdate.completeMapSelected;
    },
    navigationUsableDuringInstallation() {
      return !this.downloadFullInstall;
    }
  },
  watch: {
    '$store.state.manualUpdate.step': function () {
      this.startDownloadManagerError = false;
      this.startDownloadManagerDisabled = false;
    }
  },
  methods: {
    close() {
      this.$store.commit('resetManualUpdateSelectedRegions')
      this.startDownloadManagerError = false;
      this.setStep(0)
    },
    setStep(step) {
      this.$store.commit("setManualUpdateStep", step)
    },
    setManualUpdateMode(mode) {
      this.$store.commit("setManualUpdateMode", mode)
    },
    downloadDownloadManager() {
      let dlmUrl = "https://dm.mercedes-benz-customer-solutions.com/downloadmanager/daimler/updates/Mercedes_me_Download_Manager.exe"
      if (this.$store.state.os === 'MAC') {
        dlmUrl = "https://dm.mercedes-benz-customer-solutions.com/downloadmanager/daimler/updates/Mercedes_me_Download_Manager.dmg"
      }
      window.location.href = dlmUrl
    },
    startDownloadManager() {
      // do not allow double submits
      this.startDownloadManagerDisabled = true;
      if (process.env.VUE_APP_TESTDATA === "true") {
        if (process.env.VUE_APP_START_DOWNLOAD_MANAGER_ERROR === "true") {
          this.setStartDownloadManagerError()
        } else {
          let dlmContainer = {
            downloadApiUri: "/api/v1/mapdownloads/",
            sessionKey: "9a3b94ef-2218-4f10-8986-ce01ab6eaf3a"
          }
          this.callDLM(dlmContainer)
          this.startDownloadManagerError = false;
          setTimeout(() => {
            this.startDownloadManagerDisabled = false;
          }, 1000);
        }
      } else {
        let ds;
        if (this.downloadFullInstall) {
          ds = this.createDownloadSessionFullInstall();
        } else {
          ds = this.createDownloadSession();
        }
        ds
          .then((response) => {
            let container = response.data
            this.callDLM(container)
            this.startDownloadManagerError = false;
            setTimeout(() => {
              this.startDownloadManagerDisabled = false;
            }, 1000);
          })
          .catch((error) => {
            console.log('error', error);
            this.setStartDownloadManagerError()
          })
      }
    },
    createDownloadSession() {
      let regIdsForDownload = []
      if (this.$store.state.manualUpdate.completeMapSelected) {
        regIdsForDownload = this.getAllUpdatableRegIds();
      } else {
        regIdsForDownload = this.getSelectedRegIds();
      }
      return axios.post(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/maps`, regIdsForDownload,
        {
          withCredentials: true,
        },
      )
    },
    createDownloadSessionFullInstall() {
      return axios.post(`/mapupdate/api/v1/vehicles/${this.$store.state.vin}/maps/fullinstall`,
        {
          withCredentials: true,
        },
      )
    },
    callDLM(container) {
      let config = {
        rootContext: this.$store.state.baseURL,
        downloadApiUrl: container.downloadApiUri,
        sessionID: container.sessionKey,
        locale: this.$store.state.language + '_' + this.$store.state.country,
        navigationUsableDuringInstallation: this.navigationUsableDuringInstallation
      };

      console.log('DLM config', config);

      var jsonString = JSON.stringify(config);
      var base64String = window.btoa(encodeURIComponent(jsonString));
      var link = "mercedesme:" + base64String;

      window.location = link;
    },
    getAllUpdatableRegIds() {
      return this.$store.state.mapupdateInformation.mapRegions
        .filter(r => !r.upToDate || !r.sdsUpToDate)
        .map(r => r.regId);
    },
    getSelectedRegIds() {
      let regIds = this.$store.state.manualUpdate.selectedRegions.map(r => r.regId);
      let otaRegion = this.$store.getters.getSelectedOtaRegion;
      if (this.shouldAddSdsForHomeRegion(otaRegion)) {
        regIds.push(otaRegion.regId)
      }
      return regIds;
    },
    updateCompleteMapSelected(completeMapSelected) {
      this.$store.commit('updateCompleteMapSelected', completeMapSelected)
    },
    calculateWbStepperStatus(step) {
      if (step < this.$store.state.manualUpdate.step) {
        return "done"
      }
      if (step > this.$store.state.manualUpdate.step) {
        return "disabled"
      }
      if (step === this.$store.state.manualUpdate.step) {
        return "default"
      }
    },
    fileSizeOfRegions(regions) {
      let size = 0
      for (var i = 0; i < regions.length; i++) {
        size += regions[i].fileSize + regions[i].sdsFileSize;
      }
      size += this.getExtraDataSize()
      return FileSizeFormatter.formatToGB(size);
    },
    getExtraDataSize() {
      let size = 524288000
      let otaRegion = this.$store.getters.getSelectedOtaRegion
      if (this.shouldAddSdsForHomeRegion(otaRegion)) {
        size += otaRegion.sdsFileSize
      }
      return size
    },
    shouldAddSdsForHomeRegion(otaRegion) {
      return otaRegion !== undefined && otaRegion.upToDate && !otaRegion.sdsUpToDate;
    },
    getUsbImagePath() {
      return this.$publicPath + "usbstick.svg"
    },
    setStartDownloadManagerError() {
      this.startDownloadManagerError = true
    },
    toggleRegion(region) {
      this.$store.commit('toggleManualUpdateSelectedRegion', region);
    },
    formatToGB(size) {
      return FileSizeFormatter.formatToGB(size);
    }
  }
})
;
</script>
<style lang="scss">

</style>
